const state = {
  network_list: [],
  client_selected: undefined
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/network/network.state.js
// module id = null
// module chunks = 